<template>
  <div class="my-24 grid grid-cols-4 border-t border-grey400 justify-center pt-24">
    <div
      v-for="col in product.flavorProfile"
      :key="col.code"
      class=""
    >
      <div
        v-if="col.code"
        ref="tooltipGroup"
        class="mx-auto group relative"
        @click="toggleTooltip(col.code)"
      >
        <div class="text-[10px] font-medium sm:text-xsmall-medium sm:text-small-medium text-center mb-12">{{ col.name }}</div>
        <div class="palette w-48 h-48 relative block overflow-hidden mx-auto">
          <div
            v-for="n in 8"
            :key="n"
            class="section"
            :class="{
              '!border-black': Number(col.value) >= n
            }"
          />
        </div>
        <div
          v-if="tooltopDescription(col.code)"
          class="transition-all opacity-0 pointer-events-none py-8 sm:px-16 bg-black text-white text-center absolute z-10 tooltip-top group-hover:opacity-100 text-[10px] sm:text-tiny sm:w-auto sm:nowrap top-0 left-0 transform -translate-x-[50%] ml-[50%] -mt-8 lg:block sm:text-nowrap rounded-sm max-w-[175px] sm:max-w-[none] sm:whitespace-nowrap text-wrap -translate-y-2/3 w-112 p-8 sm:translate-y-0"
          :class="{
            '!opacity-100': activeTooltip === col.code
          }"
        >
          <div>{{ tooltopDescription(col.code) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
    
<script setup lang="ts">
import { type IProduct } from '~/api-types';
import { useGlobalContentStore } from '~/store/globalContent';
import useDetectOutsideClick from '~/composables/useDetectOutsideClick';
const productResources = useGlobalContentStore().productResources;
const activeTooltip = ref('');
defineProps<{
  product: IProduct;
}>();

const toggleTooltip = (code: string) => {
  activeTooltip.value = code;
};

const tooltipGroup = ref();

useDetectOutsideClick(tooltipGroup, () => {
  activeTooltip.value = '';
});

const tooltopDescription = (code: string) => {
  switch (code) {
    case 'smakintensitet':
      return productResources.flavorProfileDescriptionSmakintensitet;
    case 'tobakssmak':
      return productResources.flavorProfileDescriptionTobakssmak;
    case 'friskhet':
      return productResources.flavorProfileDescriptionFriskhet;
    case 'sotma':
      return productResources.flavorProfileDescriptionSotma;
    default:
      return '';
  }
};
</script>
<style scoped>
.palette {
  --g: 4px;
}
.palette > * {
  @apply border-grey400 border-[5px];
  position:absolute;
  top:0;
  left:0;
  right:0;
  bottom:0;
  border-radius:50%;
  clip-path:polygon(
    calc(50% + var(--g)/2) 50%, 
    calc(50% + var(--g)/2) 0%, 
    100% 0%,
    100% calc(0% - var(--g)/2),
    50% calc(50% - var(--g)/2)); 
}
.section:nth-child(2) {
  transform:rotate(45deg);
}
.section:nth-child(3) {
  transform:rotate(90deg);
}
.section:nth-child(4) {
  transform:rotate(135deg);
}
.section:nth-child(5) {
  transform:rotate(180deg);
}
.section:nth-child(6) {
  transform:rotate(-135deg);
}
.section:nth-child(7) {
  transform:rotate(-90deg);
}
.section:nth-child(8) {
  transform:rotate(-45deg);
}
.tooltip-top::after {
  content: "";
  position: absolute;
  top: 100%;
  border-width: 5px;
  border-style: solid;
  border-color: #000 transparent transparent transparent;
  @apply transform -translate-x-1/2 left-1/2;
}
</style>
